// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__25E7b","modal":"Modal_modal__2m6bH","header":"Modal_header__1Ahhi","content":"Modal_content__3Xs-8","footer":"Modal_footer__U_6E5"};